import React from "react";
import { IconButton } from "../icon-button";
import { useIsOverviewMode } from "../../hooks/useIsOverviewMode";
import { useGoogleAnalytics } from "../../hooks/useGoogleAnalytics";

export const SpreadOverviewButton = () => {
	const [, setIsOverviewMode] = useIsOverviewMode();
	const googleAnalytics = useGoogleAnalytics();

	return (
		<IconButton
			iconName="spread-overview"
			elevated
			onClick={() => {
				googleAnalytics.trackEventToGa({
					trackingAction: "OverviewClicked",
				});
				setIsOverviewMode(true);
			}}
		/>
	);
};
